// index.js or App.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ModalProvider } from "./store/modal-context";
import "./styles/theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ModalProvider>
      <App />
    </ModalProvider>
  </React.StrictMode>
);
